import React from 'react'
import Icons from './icons'

export default function CalendarNavigation({className="", prev, next, date }) {
  return (
    <div className={`calendar-navigation-bx ${className}`}>
        <div className="cnb-btn" onClick={prev}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="size-6">
  <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
</svg>
</div>
        <div className="cnb-date">{date}</div>
        <div className="cnb-btn" onClick={next}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="size-6">
  <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
</svg>
</div>
    </div>
  )
}
